import { checkLevelUpFeatureFlagEnabled } from 'utils/helpers/featureFlags';

import BellNotificationImg from 'assets/images/bell_notifications.png';
import BrowserNotificationImg from 'assets/images/browser_notifications.png';
import EmailNotificationImg from 'assets/images/email_notifications.png';
import SlackNotificationImg from 'assets/images/slack_notifications.png';

import {
  ENGAGEMENT_ADMIN,
  FEEDBACK_ADMIN,
  GOAL_ADMIN,
  ONE_ON_ONE_ADMIN,
  PLATFORM_ADMIN,
  REVIEW_ADMIN,
  TASK_ADMIN,
} from 'constants/ProjectConstants';

export const EVENT_MODULE_ENUM = {
  GOAL_PLANNING: 'GOAL_PLANNING',
  GOAL_CHECKIN: 'GOAL_CHECKIN',
  GOAL_COMPLETION: 'GOAL_COMPLETION',
  ONE_ON_ONE_SCHEDULE: 'ONE_ON_ONE_SCHEDULE',
  ONE_ON_ONE_COMPLETION: 'ONE_ON_ONE_COMPLETION',
  REVIEW_COMPLETION_WORKFLOW: 'REVIEW_COMPLETION_WORKFLOW',
  REVIEW_CALIBRATION: 'REVIEW_CALIBRATION',
  REVIEW_PUBLISH: 'REVIEW_PUBLISH',
  REVIEW_COMPLETION: 'REVIEW_COMPLETION',
  ADMINISTRATION_ALERTS: 'ADMINISTRATION_ALERTS',
  TAGGED_IN_COMMENTS: 'TAGGED_IN_COMMENTS',
  FEEDBACKS: 'FEEDBACKS',
  COMPETENCY_PROGRESS: 'COMPETENCY_PROGRESS',
  TIPS_AND_HOW_TO_DO: 'TIPS_AND_HOW_TO_DO',
  NEW_USER_ONBOARDING: 'NEW_USER_ONBOARDING',
  MESH_RECOMMENDS: 'MESH_RECOMMENDS',
  TASK_PLANNING: 'TASK_PLANNING',
  TASK_CHECKIN: 'TASK_CHECKIN',
  ENGAGEMENT_COMPLETION: 'ENGAGEMENT_COMPLETION',
};

export const FE_MODULE_TO_BE_MODULE_NAME_MAP = {
  GOAL_PLANNING: 'GOAL',
  GOAL_CHECKIN: 'GOAL',
  GOAL_COMPLETION: 'GOAL',
  ONE_ON_ONE_SCHEDULE: 'ONE_ON_ONE_V2',
  ONE_ON_ONE_COMPLETION: 'ONE_ON_ONE_V2',
  REVIEW_COMPLETION_WORKFLOW: 'REVIEW',
  REVIEW_CALIBRATION: 'REVIEW',
  REVIEW_PUBLISH: 'REVIEW',
  REVIEW_COMPLETION: 'REVIEW',
  ADMINISTRATION_ALERTS: 'MESH_PLATFORM',
  FEEDBACKS: 'FEEDBACK',
  COMPETENCY_PROGRESS: 'FEEDBACK',
  // TIPS_AND_HOW_TO_DO: 'TIPS_AND_HOW_TO_DO',
  NEW_USER_ONBOARDING: 'MESH_PLATFORM',
  MESH_RECOMMENDS: 'MESH_PLATFORM',
  TAGGED_IN_COMMENTS: 'MESH_PLATFORM',
  TASK_PLANNING: 'TASK',
  TASK_CHECKIN: 'TASK',
  ENGAGEMENT_COMPLETION: 'ENGAGEMENT',
};

export const EVENTS_ENUM = {
  GOAL_CREATION: 'GOAL_CREATION',
  GOAL_ANNOUNCEMENTS: 'GOAL_ANNOUNCEMENTS',
  GOAL_CREATION_REMINDER: 'GOAL_CREATION_REMINDER',
  GOAL_CREATION_SUMMARY: 'GOAL_CREATION_SUMMARY',
  GOAL_DETAILS_UPDATE: 'GOAL_DETAILS_UPDATE',
  GOAL_CHECKIN: 'GOAL_CHECKIN',
  GOAL_ARCHIVAL: 'GOAL_ARCHIVAL',
  GOAL_CHECKIN_REMINDER: 'GOAL_CHECKIN_REMINDER',
  GOAL_CHECKIN_SUMMARY: 'GOAL_CHECKIN_SUMMARY',
  GOAL_COMPLETION_REMINDERS: 'GOAL_COMPLETION_REMINDERS',
  GOAL_COMPLETION_SUMMARIES: 'GOAL_COMPLETION_SUMMARIES',
  ONE_ON_ONE_SCHEDULE: 'ONE_ON_ONE_SCHEDULE',
  ONE_ON_ONE_SCHEDULE_LAUNCH: 'ONE_ON_ONE_SCHEDULE_LAUNCH',
  ONE_ON_ONE_SCHEDULE_SUMMARY: 'ONE_ON_ONE_SCHEDULE_SUMMARY',
  ONE_ON_ONE_COMPLETION: 'ONE_ON_ONE_COMPLETION',
  ONE_ON_ONE_COMPLETION_REMINDERS: 'ONE_ON_ONE_COMPLETION_REMINDERS',
  ONE_ON_ONE_COMPLETION_SUMMARY: 'ONE_ON_ONE_COMPLETION_SUMMARY',
  ONE_ON_ONE_REFRESH_TOKEN_FAILURE: 'ONE_ON_ONE_REFRESH_TOKEN_FAILURE',
  REVIEW_NOMINATIONS: 'REVIEW_NOMINATIONS',
  REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS: 'REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS',
  REVIEW_CYCLE_REMINDER: 'REVIEW_CYCLE_REMINDER',
  ENGAGEMENT_REMINDER: 'ENGAGEMENT_REMINDER',
  REVIEW_COMPLETION_REMINDERS: 'REVIEW_COMPLETION_REMINDERS',
  REVIEW_MANUAL_REMINDERS: 'REVIEW_MANUAL_REMINDERS',
  REVIEW_COMPLETION_SUMMARIES: 'REVIEW_COMPLETION_SUMMARIES',
  REVIEW_REOPENS: 'REVIEW_REOPENS',
  REVIEW_SUBMITS: 'REVIEW_SUBMITS',
  REVIEW_CALIBRATION: 'REVIEW_CALIBRATION',
  REVIEW_PUBLISH: 'REVIEW_PUBLISH',
  REVIEW_PUBLISH_REMINDERS: 'REVIEW_PUBLISH_REMINDERS',
  REVIEW_PUBLISH_SUMMARIES: 'REVIEW_PUBLISH_SUMMARIES',
  REVIEW_UNPUBLISH: 'REVIEW_UNPUBLISH',
  REVIEW_ACKNOWLEDGED: 'REVIEW_ACKNOWLEDGED',
  REVIEW_ACKNOWLEDGEMENT_SUMMARY: 'REVIEW_ACKNOWLEDGEMENT_SUMMARY',
  REVIEW_PLATFORM_UPDATE: 'REVIEW_PLATFORM_UPDATE',
  FEEDBACK_REQUEST: 'FEEDBACK_REQUEST',
  FEEDBACK_SHARED: 'FEEDBACK_SHARED',
  FEEDBACK_ANNOUNCEMENTS: 'FEEDBACK_ANNOUNCEMENTS',
  FEEDBACK_REMINDERS: 'FEEDBACK_REMINDERS',
  FEEDBACK_STANDING_SUMMARY: 'FEEDBACK_STANDING_SUMMARY',
  NEW_USER_PLATFORM_ONBOARDING: 'NEW_USER_PLATFORM_ONBOARDING',
  EMPLOYEE_LIFECYCLE_MOMENTS: 'EMPLOYEE_LIFECYCLE_MOMENTS',
  COLLABORATION: 'COLLABORATION',
  BELONGING: 'BELONGING',
  PERFORMANCE: 'PERFORMANCE',
  GROWTH: 'GROWTH',
  PLATFORM_USER_TAGGED: 'PLATFORM_USER_TAGGED',
  TASK_CREATION: 'TASK_CREATION',
  TASK_DETAILS_UPDATE: 'TASK_DETAILS_UPDATE',
  TASK_PROGRESS_UPDATE: 'TASK_PROGRESS_UPDATE',
  TASK_COMMENT: 'TASK_COMMENT',
  TASK_DELETION: 'TASK_DELETION',
  SURVEY_LAUNCH: 'SURVEY_LAUNCH',
  SURVEY_COMPLETION_REMINDERS: 'SURVEY_COMPLETION_REMINDERS',
  SURVEY_COMPLETION_SUMMARY: 'SURVEY_COMPLETION_SUMMARY',
  SURVEY_RESULT_SUMMARY: 'SURVEY_RESULT_SUMMARY',
  SURVEY_REMINDERS: 'SURVEY_REMINDERS',
  REVIEW_ACTION_PLAN: 'REVIEW_ACTION_PLAN',
};

// Commented events will be enabled later
// whenever adding new section for events(new module), make sure to update FE_MODULE_TO_BE_MODULE_NAME_MAP and EVENT_MODULE_ENUM
export const API_EVENTS_TO_FE_EVENTS_MAPPING = {
  REVIEW_NOMINATIONS: EVENTS_ENUM.REVIEW_NOMINATIONS,
  [EVENTS_ENUM.REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS]: EVENTS_ENUM.REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS,
  REVIEW_REQUEST_UPDATE: EVENTS_ENUM.REVIEW_MANUAL_REMINDERS,
  [EVENTS_ENUM.REVIEW_COMPLETION_REMINDERS]: EVENTS_ENUM.REVIEW_COMPLETION_REMINDERS,
  REVIEW_REOPENS: EVENTS_ENUM.REVIEW_REOPENS,
  REVIEW_SUBMIT: EVENTS_ENUM.REVIEW_SUBMITS,
  REVIEW_CALIBRATION: EVENTS_ENUM.REVIEW_CALIBRATION,
  REVIEW_PUBLISH: EVENTS_ENUM.REVIEW_PUBLISH,
  [EVENTS_ENUM.REVIEW_PUBLISH_REMINDERS]: EVENTS_ENUM.REVIEW_PUBLISH_REMINDERS,
  REVIEW_UNPUBLISH: EVENTS_ENUM.REVIEW_UNPUBLISH,
  [EVENTS_ENUM.REVIEW_ACKNOWLEDGED]: EVENTS_ENUM.REVIEW_ACKNOWLEDGED,
  // REVIEW_PLATFORM_UPDATE: EVENTS_ENUM.REVIEW_PLATFORM_UPDATE,
  GOAL_ANNOUNCEMENTS: EVENTS_ENUM.GOAL_ANNOUNCEMENTS,
  GOAL_CREATION_REMINDER: EVENTS_ENUM.GOAL_CREATION_REMINDER,
  [EVENTS_ENUM.GOAL_CHECKIN_REMINDER]: EVENTS_ENUM.GOAL_CHECKIN_REMINDER,
  GOAL_CREATION: EVENTS_ENUM.GOAL_CREATION,
  GOAL_DETAILS_UPDATE: EVENTS_ENUM.GOAL_DETAILS_UPDATE,
  GOAL_CHECKIN: EVENTS_ENUM.GOAL_CHECKIN,
  GOAL_DELETION: EVENTS_ENUM.GOAL_ARCHIVAL,
  GOAL_COMPLETION_REMINDERS: EVENTS_ENUM.GOAL_COMPLETION_REMINDERS,
  GOAL_COMPLETION_SUMMARY: EVENTS_ENUM.GOAL_COMPLETION_SUMMARIES,
  TASK_CREATION: EVENTS_ENUM.TASK_CREATION,
  TASK_DETAILS_UPDATE: EVENTS_ENUM.TASK_DETAILS_UPDATE,
  TASK_PROGRESS_UPDATE: EVENTS_ENUM.TASK_PROGRESS_UPDATE,
  TASK_DELETION: EVENTS_ENUM.TASK_DELETION,
  OOO_SCHEDULE: EVENTS_ENUM.ONE_ON_ONE_SCHEDULE,
  OOO_ANNOUNCEMENTS: EVENTS_ENUM.ONE_ON_ONE_SCHEDULE_LAUNCH,
  OOO_COMPLETION_SUMMARY: EVENTS_ENUM.ONE_ON_ONE_COMPLETION,
  OOO_REMINDER: EVENTS_ENUM.ONE_ON_ONE_COMPLETION_REMINDERS,
  OOO_STATUS_SUMMARY: EVENTS_ENUM.ONE_ON_ONE_COMPLETION_SUMMARY,
  [EVENTS_ENUM.ONE_ON_ONE_REFRESH_TOKEN_FAILURE]: EVENTS_ENUM.ONE_ON_ONE_REFRESH_TOKEN_FAILURE,
  FEEDBACK_REQUEST: EVENTS_ENUM.FEEDBACK_REQUEST,
  FEEDBACK_SHARED: EVENTS_ENUM.FEEDBACK_SHARED,
  FEEDBACK_ANNOUNCEMENTS: EVENTS_ENUM.FEEDBACK_ANNOUNCEMENTS,
  FEEDBACK_REMINDERS: EVENTS_ENUM.FEEDBACK_REMINDERS,
  FEEDBACK_PROGRESS_SUMMARY: EVENTS_ENUM.FEEDBACK_STANDING_SUMMARY,
  PLATFORM_ONBOARDING: EVENTS_ENUM.NEW_USER_PLATFORM_ONBOARDING,
  // EMPLOYEE_LIFECYCLE_MOMENTS: EVENTS_ENUM.EMPLOYEE_LIFECYCLE_MOMENTS,
  // COLLABORATION: EVENTS_ENUM.COLLABORATION,
  // BELONGING: EVENTS_ENUM.BELONGING,
  PERFORMANCE: EVENTS_ENUM.PERFORMANCE,
  // GROWTH: EVENTS_ENUM.GROWTH,
  PLATFORM_USER_TAGGED: EVENTS_ENUM.PLATFORM_USER_TAGGED,
  [EVENTS_ENUM.SURVEY_COMPLETION_REMINDERS]: EVENTS_ENUM.SURVEY_COMPLETION_REMINDERS,
  REVIEW_ACTION_PLAN: EVENTS_ENUM.REVIEW_ACTION_PLAN,
};

export const EVENTS_CATEGORY_MAP = {
  [EVENTS_ENUM.GOAL_ANNOUNCEMENTS]: {
    category: EVENT_MODULE_ENUM.GOAL_PLANNING,
  },
  [EVENTS_ENUM.GOAL_CREATION_REMINDER]: {
    category: EVENT_MODULE_ENUM.GOAL_PLANNING,
  },
  [EVENTS_ENUM.GOAL_CREATION]: {
    category: EVENT_MODULE_ENUM.GOAL_PLANNING,
  },
  [EVENTS_ENUM.GOAL_CREATION_SUMMARY]: {
    category: EVENT_MODULE_ENUM.GOAL_PLANNING,
  },
  [EVENTS_ENUM.GOAL_DETAILS_UPDATE]: {
    category: EVENT_MODULE_ENUM.GOAL_CHECKIN,
  },
  [EVENTS_ENUM.GOAL_CHECKIN]: {
    category: EVENT_MODULE_ENUM.GOAL_CHECKIN,
  },
  [EVENTS_ENUM.GOAL_ARCHIVAL]: {
    category: EVENT_MODULE_ENUM.GOAL_CHECKIN,
  },
  [EVENTS_ENUM.GOAL_CHECKIN_REMINDER]: {
    category: EVENT_MODULE_ENUM.GOAL_CHECKIN,
  },
  [EVENTS_ENUM.GOAL_CHECKIN_SUMMARY]: {
    category: EVENT_MODULE_ENUM.GOAL_CHECKIN,
  },
  [EVENTS_ENUM.GOAL_COMPLETION_REMINDERS]: {
    category: EVENT_MODULE_ENUM.GOAL_COMPLETION,
  },
  [EVENTS_ENUM.GOAL_COMPLETION_SUMMARIES]: {
    category: EVENT_MODULE_ENUM.GOAL_COMPLETION,
  },
  [EVENTS_ENUM.ONE_ON_ONE_SCHEDULE]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_SCHEDULE,
  },
  [EVENTS_ENUM.ONE_ON_ONE_SCHEDULE_LAUNCH]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_SCHEDULE,
  },
  [EVENTS_ENUM.ONE_ON_ONE_SCHEDULE_SUMMARY]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_SCHEDULE,
  },
  [EVENTS_ENUM.ONE_ON_ONE_COMPLETION]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_COMPLETION,
  },
  [EVENTS_ENUM.ONE_ON_ONE_COMPLETION_REMINDERS]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_COMPLETION,
  },
  [EVENTS_ENUM.ONE_ON_ONE_COMPLETION_SUMMARY]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_COMPLETION,
  },
  [EVENTS_ENUM.ONE_ON_ONE_REFRESH_TOKEN_FAILURE]: {
    category: EVENT_MODULE_ENUM.ONE_ON_ONE_SCHEDULE,
  },
  [EVENTS_ENUM.REVIEW_NOMINATIONS]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_CYCLE_REMINDER]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_COMPLETION_REMINDERS]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_MANUAL_REMINDERS]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_COMPLETION_SUMMARIES]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_REOPENS]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_SUBMITS]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_CALIBRATION]: {
    category: EVENT_MODULE_ENUM.REVIEW_CALIBRATION,
  },
  [EVENTS_ENUM.REVIEW_PUBLISH]: {
    category: EVENT_MODULE_ENUM.REVIEW_PUBLISH,
  },
  [EVENTS_ENUM.REVIEW_PUBLISH_REMINDERS]: {
    category: EVENT_MODULE_ENUM.REVIEW_PUBLISH,
  },
  [EVENTS_ENUM.REVIEW_PUBLISH_SUMMARIES]: {
    category: EVENT_MODULE_ENUM.REVIEW_PUBLISH,
  },
  [EVENTS_ENUM.REVIEW_UNPUBLISH]: {
    category: EVENT_MODULE_ENUM.REVIEW_PUBLISH,
  },
  [EVENTS_ENUM.REVIEW_ACKNOWLEDGED]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_ACKNOWLEDGEMENT_SUMMARY]: {
    category: EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW,
  },
  [EVENTS_ENUM.REVIEW_PLATFORM_UPDATE]: {
    category: EVENT_MODULE_ENUM.ADMINISTRATION_ALERTS,
  },
  [EVENTS_ENUM.FEEDBACK_REQUEST]: {
    category: EVENT_MODULE_ENUM.FEEDBACKS,
  },
  [EVENTS_ENUM.FEEDBACK_SHARED]: {
    category: EVENT_MODULE_ENUM.FEEDBACKS,
  },
  [EVENTS_ENUM.FEEDBACK_ANNOUNCEMENTS]: {
    category: EVENT_MODULE_ENUM.FEEDBACKS,
  },
  [EVENTS_ENUM.FEEDBACK_REMINDERS]: {
    category: EVENT_MODULE_ENUM.FEEDBACKS,
  },
  [EVENTS_ENUM.FEEDBACK_STANDING_SUMMARY]: {
    category: EVENT_MODULE_ENUM.COMPETENCY_PROGRESS,
  },
  [EVENTS_ENUM.NEW_USER_PLATFORM_ONBOARDING]: {
    category: EVENT_MODULE_ENUM.NEW_USER_ONBOARDING,
  },
  [EVENTS_ENUM.EMPLOYEE_LIFECYCLE_MOMENTS]: {
    category: EVENT_MODULE_ENUM.MESH_RECOMMENDS,
  },
  [EVENTS_ENUM.COLLABORATION]: {
    category: EVENT_MODULE_ENUM.MESH_RECOMMENDS,
  },
  [EVENTS_ENUM.BELONGING]: {
    category: EVENT_MODULE_ENUM.MESH_RECOMMENDS,
  },
  [EVENTS_ENUM.PERFORMANCE]: {
    category: EVENT_MODULE_ENUM.MESH_RECOMMENDS,
  },
  [EVENTS_ENUM.GROWTH]: {
    category: EVENT_MODULE_ENUM.MESH_RECOMMENDS,
  },
  [EVENTS_ENUM.PLATFORM_USER_TAGGED]: {
    category: EVENT_MODULE_ENUM.TAGGED_IN_COMMENTS,
  },
  [EVENTS_ENUM.TASK_CREATION]: {
    category: EVENT_MODULE_ENUM.TASK_PLANNING,
  },
  [EVENTS_ENUM.TASK_DETAILS_UPDATE]: {
    category: EVENT_MODULE_ENUM.TASK_CHECKIN,
  },
  [EVENTS_ENUM.TASK_PROGRESS_UPDATE]: {
    category: EVENT_MODULE_ENUM.TASK_CHECKIN,
  },
  [EVENTS_ENUM.TASK_COMMENT]: {
    category: EVENT_MODULE_ENUM.TASK_CHECKIN,
  },
  [EVENTS_ENUM.TASK_DELETION]: {
    category: EVENT_MODULE_ENUM.TASK_CHECKIN,
  },
  [EVENTS_ENUM.SURVEY_LAUNCH]: {
    category: EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION,
  },
  [EVENTS_ENUM.SURVEY_COMPLETION_REMINDERS]: {
    category: EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION,
  },
  [EVENTS_ENUM.SURVEY_COMPLETION_SUMMARY]: {
    category: EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION,
  },
  [EVENTS_ENUM.SURVEY_RESULT_SUMMARY]: {
    category: EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION,
  },
  [EVENTS_ENUM.ENGAGEMENT_REMINDER]: {
    category: EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION,
  },
  [EVENTS_ENUM.REVIEW_ACTION_PLAN]: {
    category: EVENT_MODULE_ENUM.MESH_RECOMMENDS,
  },
};

export const REVIEW_COMPLETION_WORKFLOW_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.REVIEW_NOMINATIONS]: {
    heading: 'Review Nominations',
    description:
      'Get notified when there are updates for you in review nomination process (e.g. peer nomination, DLM nomination)',
    order: 1,
  },
  [EVENTS_ENUM.REVIEW_CYCLE_LAUNCH_ANNOUNCEMENTS]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Review cycle launch announcements',
    description: 'Get notified when there are updates for you in review completion process',
    message: 'Configured via Review Settings',
    order: 2,
  },
  [EVENTS_ENUM.REVIEW_COMPLETION_REMINDERS]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Review completion reminders',
    description: 'Reminders as configured by admins to complete pending reviews.',
    message: 'Configured via Review Settings',
    order: 3,
  },

  [EVENTS_ENUM.REVIEW_COMPLETION_SUMMARIES]: {
    heading: 'Review completion summaries',
    description: 'Scheduled summary of review completion status for current review cycle across reporting span..',
    order: 4,
  },
  [EVENTS_ENUM.REVIEW_REOPENS]: {
    heading: 'Review Reopens',
    description: 'Get notified when there are updates for you in review completion process.',
    order: 5,
  },
  [EVENTS_ENUM.REVIEW_ACKNOWLEDGED]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Acknowledged',
    description: 'Scheduled reminders to complete acknowledgement.',
    message: 'Configured via Review Settings',
    order: 6,
  },
  [EVENTS_ENUM.REVIEW_ACKNOWLEDGEMENT_SUMMARY]: {
    heading: 'Acknowledgment summary',
    description: 'Get notified about Acknowledgement updates.',
    order: 7,
  },
  [EVENTS_ENUM.REVIEW_SUBMITS]: {
    heading: 'Review Submits',
    description: 'Get notified when there are updates for you in review completion process.',
    order: 8,
  },
  [EVENTS_ENUM.REVIEW_MANUAL_REMINDERS]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Notify pending reviewers',
    description: 'Get notified when your colleagues or manager triggers a reminder to complete a pending review',
    message: 'These are enabled for all users.',
    order: 9,
  },

  displayName: 'Review Completion',
  order: 0,
  access: REVIEW_ADMIN,
};

export const REVIEW_CALIBRATION_WORKFLOW_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.REVIEW_CALIBRATION]: {
    heading: 'Review Calibration',
    description: 'Get notified when your reporting span has updates in review calibration process',
    order: 1,
  },

  displayName: 'Review Calibrations',
  order: 1,
  access: REVIEW_ADMIN,
};

export const REVIEW_PUBLISH_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.REVIEW_PUBLISH]: {
    heading: 'Publishing - Published to Manager/Employee',
    description: 'Get notified when reviews are published, or action pending on you to publish reviews further.',
    order: 1,
  },
  [EVENTS_ENUM.REVIEW_PUBLISH_REMINDERS]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Publishing reminders',
    description: 'Get notified when reviews are published, or action pending on you to publish reviews further.',
    message: 'Configured via Review Settings',
    order: 2,
  },
  [EVENTS_ENUM.REVIEW_PUBLISH_SUMMARIES]: {
    heading: 'Publishing summaries',
    description: 'Get notified when reviews are published, or action pending on you to publish reviews further.',
    order: 3,
  },
  [EVENTS_ENUM.REVIEW_UNPUBLISH]: {
    heading: 'Publishing - UnPublished back to Manager /Admin',
    description: 'Get notified when reviews are published, or action pending on you to publish reviews further.',
    order: 5,
  },
  displayName: 'Review results publishing',
  order: 2,
  access: REVIEW_ADMIN,
};

export const GOAL_PLANNING_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.GOAL_ANNOUNCEMENTS]: {
    heading: 'Announcements',
    description: 'Launch announcements to everyone in the company about start of new goal planning cycle',
    order: 1,
  },
  [EVENTS_ENUM.GOAL_CREATION_REMINDER]: {
    heading: 'Reminders',
    description: 'Scheduled reminders to create goal while goal planning stage is still active.',
    order: 2,
  },
  [EVENTS_ENUM.GOAL_CREATION]: {
    heading: 'Goal Creation',
    description: 'Notifications about goal creation and/or ownership changes on the goals you own/collaborate on.',
    order: 3,
  },
  [EVENTS_ENUM.GOAL_CREATION_SUMMARY]: {
    heading: 'Summaries',
    description: 'Scheduled summary of goal creation across reporting span for the current planning cycle',
    order: 4,
  },
  displayName: 'Goal planning',
  order: 5,
  access: GOAL_ADMIN,
};

export const GOAL_CHECKIN_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.GOAL_DETAILS_UPDATE]: {
    heading: 'Goal updation',
    description:
      'Notifications about goal updation events such as  Title change, due date changes, description changes etc.',
    order: 1,
  },
  [EVENTS_ENUM.GOAL_CHECKIN]: {
    heading: 'Goal check-in',
    description:
      'Notification about goal check-in event - progress check-in, adding comments, status changes, adding child goal or initiatives.',
    order: 2,
  },
  [EVENTS_ENUM.GOAL_ARCHIVAL]: {
    heading: 'Goal archival',
    description: 'Owners and managers are notified when goal is archived or unarchived.',
    order: 3,
  },
  [EVENTS_ENUM.GOAL_CHECKIN_REMINDER]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Goal check-in reminders',
    description: 'Scheduled reminders to check-in on the goals at the configured frequency.',
    message: 'Configured via Goal Settings',
    order: 4,
  },
  [EVENTS_ENUM.GOAL_CHECKIN_SUMMARY]: {
    heading: 'Goal check-in summaries',
    description: 'Scheduled summary of Goal progress and check-in across the reporting span.',
    order: 5,
  },
  displayName: 'Goal check-in',
  order: 6,
  access: GOAL_ADMIN,
};

export const GOAL_COMPLETION_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.GOAL_COMPLETION_REMINDERS]: {
    heading: 'Goal completion Reminders',
    description: 'At the end of goal cycle, send reminders to mark goals as ‘Completed’',
    order: 2,
  },
  [EVENTS_ENUM.GOAL_COMPLETION_SUMMARIES]: {
    heading: 'Goal completion summaries',
    description: 'Scheduled summary of Goal progress and completion statuses across the reporting span.',
    order: 3,
  },
  displayName: 'Goal completion',
  order: 7,
  access: GOAL_ADMIN,
};

export const TASK_PLANNING_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.TASK_CREATION]: {
    heading: 'Initiatives creation',
    description:
      'Notifications about initiative creation and/or ownership changes on the initiatives you own/collaborate on.',
    order: 1,
  },

  displayName: 'Initiatives planning',
  order: 8,
  access: TASK_ADMIN,
};

export const TASK_CHECKIN_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.TASK_PROGRESS_UPDATE]: {
    heading: 'Initiative check-in',
    description: 'Notification about initiative check-in event - progress check-in, adding comments, status changes.',
    order: 1,
  },
  [EVENTS_ENUM.TASK_DETAILS_UPDATE]: {
    heading: 'Initiatives updates',
    description: 'Notifications about initiative updation events such as  Title change, tags etc.',
    order: 2,
  },
  [EVENTS_ENUM.TASK_DELETION]: {
    heading: 'Initiative archival',
    description: 'Owners and managers are notified when initiative is archived or unarchived.',
    order: 3,
  },

  displayName: 'Initiative check-in',
  order: 9,
  access: TASK_ADMIN,
};

export const ONE_ON_ONE_SCHEDULE_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.ONE_ON_ONE_SCHEDULE]: {
    heading: '1:1 Schedule',
    description: 'Notifications about 1:1 creations, cancellations,archival and schedule changes',
    order: 1,
  },
  [EVENTS_ENUM.ONE_ON_ONE_SCHEDULE_LAUNCH]: {
    heading: '1:1 Schedule launch',
    description: 'Every quarter, employees get notifications if their manager 1:1s are not already scheduled',
    order: 2,
  },
  [EVENTS_ENUM.ONE_ON_ONE_SCHEDULE_SUMMARY]: {
    heading: '1:1 Scheduling Summary',
    description: 'Summary of 1:1s created across the reporting span.',
    order: 3,
  },
  [EVENTS_ENUM.ONE_ON_ONE_REFRESH_TOKEN_FAILURE]: {
    isNotControlledByNotificationSettings: true,
    heading: '1:1 calendar sync failure',
    description: '.',
    message: 'These are enabled for all users.',
    order: 4,
  },
  displayName: '1:1 Schedule',
  order: 10,
  access: ONE_ON_ONE_ADMIN,
};

export const ONE_ON_ONE_COMPLETION_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.ONE_ON_ONE_COMPLETION]: {
    heading: '1:1 Completion',
    description: 'Scheduled summary of 1:1 completion statuses across reporting span',
    order: 1,
  },
  [EVENTS_ENUM.ONE_ON_ONE_COMPLETION_REMINDERS]: {
    heading: '1:1 Completion reminders',
    description: 'Scheduled reminders (24 hours) before your upcoming 1:1s',
    order: 2,
  },
  [EVENTS_ENUM.ONE_ON_ONE_COMPLETION_SUMMARY]: {
    heading: '1:1 Completion Summary',
    description: 'Summary of 1:1s completions, and related metrics across the reporting span.',
    order: 3,
  },

  displayName: '1:1 Completion',
  order: 11,
  access: ONE_ON_ONE_ADMIN,
};

export const FEEDBACKS_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.FEEDBACK_REQUEST]: {
    heading: 'Feedbacks requested',
    description: 'Get notified when someone requests or shares a feedback.',
    order: 1,
  },
  [EVENTS_ENUM.FEEDBACK_SHARED]: {
    heading: 'Feedbacks shared',
    description: 'Get notified when someone requests or shares a feedback.',
    order: 2,
  },
  [EVENTS_ENUM.FEEDBACK_ANNOUNCEMENTS]: {
    heading: 'Feedbacks announcements',
    description: 'Announcement for launch Development cycle and frequency as configured.',
    order: 3,
  },
  [EVENTS_ENUM.FEEDBACK_REMINDERS]: {
    heading: 'Feedbacks share reminders',
    description: 'Reminders to complete development check-ins.',
    order: 4,
  },

  displayName: 'Feedbacks',
  order: 12,
  access: FEEDBACK_ADMIN,
};

export const COMPETENCY_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.FEEDBACK_STANDING_SUMMARY]: {
    heading: 'Competency progress summaries',
    description: 'Summary of competency scores and development check-ins across reporting span.',
    order: 1,
  },

  displayName: 'Competency progress',
  order: 12.1,
  access: FEEDBACK_ADMIN,
};

export const ENGAGEMENT_COMPLETION_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.SURVEY_LAUNCH]: {
    heading: 'Survey launch',
    description: 'Launch email when a engagement survey is created for you to complete.',
    order: 1,
  },
  [EVENTS_ENUM.SURVEY_COMPLETION_REMINDERS]: {
    isNotControlledByNotificationSettings: true,
    heading: 'Survey completion reminders',
    description: 'Reminders as configured by admins to complete pending surveys.',
    message: 'Configured via Engagement Settings',
    order: 2,
  },
  [EVENTS_ENUM.SURVEY_COMPLETION_SUMMARY]: {
    heading: 'Survey completion summary',
    description: `Scheduled summary of survey completion for current engagement survey across reporting span.`,
    order: 3,
  },
  [EVENTS_ENUM.SURVEY_RESULT_SUMMARY]: {
    heading: 'Survey results summary',
    description: 'Scheduled summary of survey results for current engagement survey across reporting span.',
    order: 4,
  },
  displayName: 'Engagement Completion',
  order: 13,
  access: ENGAGEMENT_ADMIN,
};

export const PLATFORM_ONBOARDING_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.NEW_USER_PLATFORM_ONBOARDING]: {
    heading: 'Platform Onboarding',
    description: `A tailored introduction to our platform's key features. This ensures they hit the ground running and quickly unlock the full potential of our tools`,
    order: 1,
  },
  displayName: 'New user onboarding',
  order: 14,
  access: PLATFORM_ADMIN,
};

export const ADMINISTRATION_ALERTS_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.REVIEW_PLATFORM_UPDATE]: {
    heading: 'Add/remove an administrator',
    description: 'Administrative permission changes.',
    order: 1,
  },

  displayName: 'Administration alerts',
  order: 14.1,
  access: PLATFORM_ADMIN,
};

export const MESH_RECOMMENDS_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.EMPLOYEE_LIFECYCLE_MOMENTS]: {
    heading: 'Employee lifecycle moments',
    description:
      'Personalized recommendations at every stage of the employee lifecycle. From warmly welcoming new joiners, guiding individuals as they reach their 30-day milestone, to celebrating one-year anniversaries, our platform suggests the most effective actions to optimise each step of the journey."',
    order: 1,
  },
  [EVENTS_ENUM.COLLABORATION]: {
    heading: 'Collaboration',
    description:
      'Ignite collaboration among teams. From linking peers tackling common goals and initiatives to fostering connections between employees striving to develop similar competencies, our platform empowers seamless collaboration and peer recognition.',
    order: 2,
  },
  [EVENTS_ENUM.BELONGING]: {
    heading: 'Belonging',
    description: `Cultivate a sense of belonging by network building, understanding and embracing one's role purpose, and gaining clarity on individual responsibilities. Mesh empowers employees to feel connected, purposeful, and confident in their contributions.`,
    order: 3,
  },
  [EVENTS_ENUM.PERFORMANCE]: {
    heading: 'Performance',
    description:
      'Facilitate a journey of continuous growth and development for individuals and teams alike. Aimed towards helping individuals or their managers understand current performance and provide guidance, leading them towards a path of improving talent density across the organisation."',
    order: 4,
  },
  [EVENTS_ENUM.GROWTH]: {
    heading: 'Growth',
    description: `Encourage the growth within one's current role and prepare individuals for their next role by prompting individuals, managers, and leaders to take appropriate actions at the opportune moment. Our approach ensures individuals are empowered to progress seamlessly in their careers.`,
    order: 5,
  },
  [EVENTS_ENUM.REVIEW_ACTION_PLAN]: {
    heading: 'Reviews plan of action',
    description: 'Notify managers with a consolidated Plan of Action from performance reviews, generated by Maven',
    order: 6,
  },
  displayName: 'Mesh recommends',
  order: 15,
  access: PLATFORM_ADMIN,
};

export const TAGGED_IN_COMMENTS_NOTIFICATION_EVENTS_META = {
  [EVENTS_ENUM.PLATFORM_USER_TAGGED]: {
    heading: 'Tagged in comments',
    description: `Your colleagues can tag you in a comment on goals, initiatives, or competency feedback. You would get notified about the tags.`,
    order: 1,
  },

  displayName: 'Tagged in comments',
  order: 16,
  access: PLATFORM_ADMIN,
};

export const NOTIFICATION_CHANNELS = {
  // FEED: {
  //   heading: 'Feed',
  //   description: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. ',
  //   img: FeedNotificationImg,
  // },
  BELL: {
    heading: 'Bell',
    description: 'The bell icon displays red badges for notifications, click it to view the most recent ones.',
    img: BellNotificationImg,
    order: 0,
  },
  EMAIL: {
    heading: 'Email',
    description: 'Email notifications will be sent to your inbox',
    img: EmailNotificationImg,
    order: 1,
  },
  BROWSER: {
    heading: 'Browser',
    description:
      'Browser notifications appear on your screen when you’re not active in Mesh, but the site is open in your browser tab or window.',
    img: BrowserNotificationImg,
    order: 4,
  },
  SLACK: {
    heading: 'Third party chat applications',
    description: 'These notifications will appear on connected third part chat applications e.g Slack. MS Teams',
    img: SlackNotificationImg,
    order: 2,
  },
};

export const GOAL_NOTIFICATION_EVENTS_META = {
  GOAL_PROGRESS_UPDATE: {
    heading: 'Goal progress',
    description: 'Get notified when there are updates in goal progress',
  },
  GOAL_CHECKIN_REMINDER: {
    heading: 'Check-in reminders',
    description: 'Get check-in reminders to update progress on your goals',
  },
  GOAL_DETAILS_UPDATE: {
    heading: 'Goal details',
    description: 'Get notified when there are updates in goal details',
  },
  GOAL_COMMENT: {
    heading: 'Goal comment',
    description: 'Get notified when someone comments on a goal in which you are marked as owner/collaborator',
  },
  GOAL_DELETION: {
    heading: 'Goal deletion',
    description: 'Get notified when someone deletes a goal in which you are marked as owner/collaborator',
  },
  GOAL_MONTHLY_DIGEST: {
    heading: 'Goal monthly digest',
    description: 'Monthly updates on goal module ',
  },
  GOAL_WEEKLY_DIGEST: {
    heading: 'Goal weekly digest',
    description: 'Weekly updates on goal module ',
  },
  GOAL_TASK: {
    heading: 'Goal task',
    description: 'Get notified when there are updates in goal task ',
  },
  displayName: 'Goals',
  order: 0,
  access: GOAL_ADMIN,
};

export const TASK_NOTIFICATION_EVENTS_META = {
  SUB_TASK: {
    heading: 'Task',
    description: 'Get notified on creation and updation of tasks ',
  },
  TASK_COMMENT: {
    heading: 'Initiative comment',
    description: 'Get notified when someone comments on a Initiative in which you are marked as owner/collaborator',
  },
  TASK_DELETION: {
    heading: 'Initiative deletion',
    description: 'Get notified when someone deletes a Initiative in which you are marked as owner/collaborator',
  },
  TASK_DETAILS_UPDATE: {
    heading: 'Initiative details update',
    description:
      'Get notified when there are updates in owner, collaborator, objective, description, start date and due date',
  },
  TASK_MONTHLY_DIGEST: {
    heading: 'Initiative monthly digest',
    description: 'Monthly updates on Initiative module ',
  },
  TASK_PROGRESS_UPDATE: {
    heading: 'Initiative progress update',
    description: 'Get notified when there are updates in status of a Initiative ',
  },
  TASK_WEEKLY_DIGEST: {
    heading: 'Initiative weekly digest',
    description: 'Weekly updates on Initiative module ',
  },
  displayName: 'Initiatives',
  order: 1,
  access: TASK_ADMIN,
};

export const ONE_ON_ONE_NOTIFICATION_EVENTS_META = {
  ACTION_ITEMS: {
    heading: 'Action items',
    description: 'Get notified on creation, updation and completion of action items',
  },
  AGENDA: {
    heading: 'Agenda',
    description: "Get notified on creation, updation and completion of meeting agenda's",
  },
  ONE_ON_ONE_COMPLETION: {
    heading: '1:1 completion',
    description: 'Get notified when a 1:1 is marked as complete',
  },
  ONE_ON_ONE_CREATION: {
    heading: '1:1 creation',
    description: 'Get notified when someone tags you in a 1:1',
  },
  ONE_ON_ONE_MONTHLY_DIGEST: {
    heading: '1:1 monthly digest',
    description: 'Monthly updates on 1:1 module ',
  },
  ONE_ON_ONE_WEEKLY_DIGEST: {
    heading: '1:1 weekly digest',
    description: 'Weekly updates on 1:1 module ',
  },
  SCHEDULE_MODIFICATION: {
    heading: '1:1 schedule modification',
    description: 'Get notified when there is a modification in 1:1 schedule ',
  },
  ONE_ON_ONE_REMINDER: {
    heading: '1:1 reminder',
    description: 'Get a reminder before a scheduled 1:1',
  },
  displayName: '1:1',
  order: 2,
  access: ONE_ON_ONE_ADMIN,
};

export const ONE_ON_ONE_NOTIFICATION_EVENTS_META_RABBIT = {
  OOO_CREATION: {
    heading: '1:1 creation',
    description: 'Get notified when someone tags you in a 1:1',
  },
  OOO_REMINDER: {
    heading: '1:1 reminder',
    description: 'Get a reminder 24 hours before your 1:1 starts',
  },
  OOO_SCHEDULE_MODIFICATION: {
    heading: '1:1 schedule modification',
    description: 'Get notified when any modification happens to existing 1:1 instance or the 1:1 schedule',
  },
  OOO_COMPLETION_SUMMARY: {
    heading: '1:1 summary',
    description: 'Receive a summary of your 1:1 via e-mail once it is complete',
  },
  displayName: '1:1',
  order: 2,
  access: ONE_ON_ONE_ADMIN,
};

export const REVIEW_NOTIFICATION_EVENTS_META = {
  FEEDBACK_REQUEST: {
    heading: 'Share or request feedback',
    description: 'Get notified when someone requests or shares a feedback',
  },
  REVIEW_MONTHLY_DIGEST: {
    heading: 'Review monthly digest',
    description: 'Monthly updates on review module',
  },
  REVIEW_REQUEST_UPDATE: {
    heading: 'Review request',
    description:
      'Get notified when there are updates in peer nominations, self review, manager review and upward review',
  },
  REVIEW_WEEKLY_DIGEST: {
    heading: 'Review weekly digest',
    description: 'Weekly updates on review module',
  },
  REVIEW_CYCLE_REMINDER: {
    isNotControlledByNotificationSettings: true,
    heading: 'Review cycle reminders',
    description: 'Get reminders on the pending review form',
    message: 'Configured via individual review cycles',
  },
  displayName: 'Reviews',
  order: 3,
  access: REVIEW_ADMIN,
};

export const ENGAGEMENT_NOTIFICATION_EVENTS_META = {
  ENGAGEMENT_MONTHLY_DIGEST: {
    heading: 'Engagement monthly digest',
    description: 'Monthly updates on engagement module ',
  },
  ENGAGEMENT_REQUEST_UPDATE: {
    heading: 'Engagement request update',
    description: 'Monthly updates on engagement module ',
  },
  ENGAGEMENT_WEEKLY_DIGEST: {
    heading: 'Engagement weekly digest',
    description: 'Weekly updates on engagement module ',
  },
  ENGAGEMENT_REMINDER: {
    isNotControlledByNotificationSettings: true,
    heading: 'Engagement reminders',
    description: 'Get reminders on the pending engagement survey',
    message: 'Configured via individual engagement surveys',
  },
  displayName: 'Engagements',
  order: 4,
  access: ENGAGEMENT_ADMIN,
};

export const FEEDBACK_NOTIFICATION_EVENTS_META = {
  FEEDBACK_REQUEST: {
    heading: 'Share or request feedback',
    description: 'Get notified when someone requests or shares a feedback',
  },
  displayName: 'Feedback',
  order: 6,
  access: FEEDBACK_ADMIN,
};

export const POST_NOTIFICATION_EVENTS_META = {
  USER_CREATED_POST: {
    heading: 'Post creation',
    description: 'Get notified when someone mentions you in a feed post',
  },
  USER_REACTION: {
    heading: 'Post reaction',
    description: 'Get notified when someone comments on a feed post related to you or mentions you in a post comment',
  },
  displayName: 'Feed post',
  order: 7,
  access: FEEDBACK_ADMIN,
};

export const MESH_PLATFORM_NOTIFICATION_EVENTS_META = {
  TIPS_HOW_TOS_NOTIFICATION: {
    heading: 'Tips and how-tos',
    description: 'Occasional notifications to help you get most out of Mesh',
    order: 0,
  },
  MESH_RECOMMENDS: {
    heading: 'Mesh recommends',
    description:
      'Using people and data science-backed nudges to assist individuals in determining their next best actions',
    order: 1,
  },
  PRODUCT_UPDATE_NOTIFICATION: {
    heading: 'Product updates',
    description: 'Occasional notifications on new features and product updates',
    order: 2,
  },
  PRODUCT_RESEARCH_NOTIFICATION: {
    isNotControlledByNotificationSettings: true,
    heading: 'Product research',
    description: 'Occasional surveys to help us improve Mesh',
    order: 3,
  },
  DIGEST_NOTIFICATION: {
    isNotControlledByNotificationSettings: true,
    heading: 'Digests',
    description: 'Weekly/Monthly summary of your and your team activities',
    order: 4,
  },
  displayName: 'Mesh platform',
  order: 8,
  access: PLATFORM_ADMIN,
};

export const LEVEL_UP_EVENTS_META = {
  LEVEL_UP_CHECK_IN: {
    heading: 'Competency progress',
    description:
      "Get notified when progress has been updated for your competency or for your direct reports' competency",
    order: 1,
  },
  LEVEL_UP_COMMENT: {
    heading: 'Competency comments',
    description:
      "Get notified when a comment has been added for your competency or for your direct reports' competency",
    order: 2,
  },
  LEVEL_UP_DETAILS: {
    heading: 'Competency details',
    description:
      "Get notified when initiatives are created/deleted or target quarter has been set for your competency or for your direct reports' competency",
    order: 3,
  },
  LEVEL_UP_TARGET_ROLE: {
    heading: 'Target role selected',
    description:
      "Get notified when you are assigned a target role or when your direct reports' choose their target role",
    order: 0,
  },
  displayName: 'Develop',
  order: 5,
  access: FEEDBACK_ADMIN,
  featureFlag: checkLevelUpFeatureFlagEnabled,
};

export const NOTIFICATION_EVENTS_META = {
  GOAL: GOAL_NOTIFICATION_EVENTS_META,
  TASK: TASK_NOTIFICATION_EVENTS_META,
  REVIEW: REVIEW_NOTIFICATION_EVENTS_META,
  ENGAGEMENT: ENGAGEMENT_NOTIFICATION_EVENTS_META,
  LEVEL_UP: LEVEL_UP_EVENTS_META,
  FEEDBACK: FEEDBACK_NOTIFICATION_EVENTS_META,
  POST: POST_NOTIFICATION_EVENTS_META,
  MESH_PLATFORM: MESH_PLATFORM_NOTIFICATION_EVENTS_META,
  ONE_ON_ONE: ONE_ON_ONE_NOTIFICATION_EVENTS_META,
  ONE_ON_ONE_V2: ONE_ON_ONE_NOTIFICATION_EVENTS_META_RABBIT,
  [EVENT_MODULE_ENUM.GOAL_PLANNING]: GOAL_PLANNING_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.GOAL_CHECKIN]: GOAL_CHECKIN_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.GOAL_COMPLETION]: GOAL_COMPLETION_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.ONE_ON_ONE_SCHEDULE]: ONE_ON_ONE_SCHEDULE_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.ONE_ON_ONE_COMPLETION]: ONE_ON_ONE_COMPLETION_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.REVIEW_COMPLETION_WORKFLOW]: REVIEW_COMPLETION_WORKFLOW_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.REVIEW_CALIBRATION]: REVIEW_CALIBRATION_WORKFLOW_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.REVIEW_PUBLISH]: REVIEW_PUBLISH_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.ADMINISTRATION_ALERTS]: ADMINISTRATION_ALERTS_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.FEEDBACKS]: FEEDBACKS_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.COMPETENCY_PROGRESS]: COMPETENCY_NOTIFICATION_EVENTS_META,
  // [EVENT_MODULE_ENUM.TIPS_AND_HOW_TO_DO]: PLATFORM_TIPS_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.NEW_USER_ONBOARDING]: PLATFORM_ONBOARDING_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.MESH_RECOMMENDS]: MESH_RECOMMENDS_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.TASK_PLANNING]: TASK_PLANNING_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.TASK_CHECKIN]: TASK_CHECKIN_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.ENGAGEMENT_COMPLETION]: ENGAGEMENT_COMPLETION_NOTIFICATION_EVENTS_META,
  [EVENT_MODULE_ENUM.TAGGED_IN_COMMENTS]: TAGGED_IN_COMMENTS_NOTIFICATION_EVENTS_META,
};
